import React from 'react';
import { useParams } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';
import './assets/profile.scss'
import Header from '../../components/Header'
import StoryImage from '../../components/StoryImage'
import { MdWhatsapp, MdCall, MdCheckCircle, MdBlock, MdLocationOn, MdSend } from 'react-icons/md';
import { LinearProgress } from '@mui/material';

const Profile = () => {
  let params = useParams();
  const [item, setItem] = React.useState({})
  const [loading, setLoading] = React.useState(true)
  const [slideIndex, setSlideIndex] = React.useState(0)

  const fetchData = () => {
    fetch(`${process.env.REACT_APP_API_URL}/announcements/${params.userId}`)
      .then(response => response.json())
      .then(data => { setItem(data); setLoading(false); })
      .catch(error => { console.log(`********* ${error}`); setLoading(false); })
  }

  React.useEffect(() => {
    fetchData()
  }, [])

  const getContactButton = (ch) => {
    switch (ch) {
      case 'whatsapp':
        return (
          <a key="whatsapp" className="contact-btn whatsapp" href={`https://wa.me/${item.phone}`}>
            <MdWhatsapp />
            <span>WhatsApp</span>
          </a>
        )
      case 'direct':
        return (
          <a key="direct" className="contact-btn direct" href={`tel:${item.phone}`}>
            <MdCall />
            <span>Ara</span>
          </a>
        )
      case 'telegram':
        return (
          <a key="telegram" className="contact-btn telegram" href={`https://t.me/${item.phone}`}>
            <MdSend />
            <span>Telegram</span>
          </a>
        )
      default:
        return null
    }
  }

  if (loading) {
    return (
      <div className="profile-page">
        <Header back={true} />
        <div className="profile-loading">
          <LinearProgress color="secondary" />
        </div>
      </div>
    )
  }

  return (
    <div className="profile-page">
      <Header back={true} />

      {/* Hero Gallery */}
      <div className="hero-gallery">
        {item.media && item.media.length > 0 && (
          <>
            <ImageGallery
              items={item.media.map(i => ({ original: i, thumbnail: i }))}
              showThumbnails={item.media.length > 1}
              showFullscreenButton={true}
              showPlayButton={false}
              showBullets={false}
              showNav={item.media.length > 1}
              autoPlay={item.media.length > 1}
              slideInterval={4000}
              lazyLoad={true}
              infinite={true}
              onSlide={setSlideIndex}
              renderCustomControls={() =>
                item.media.length > 1 ? (
                  <span className="slide-counter">
                    {slideIndex + 1} / {item.media.length}
                  </span>
                ) : null
              }
            />
          </>
        )}
        <div className="hero-overlay" />
      </div>

      {/* Profile Card */}
      <div className="profile-card">
        <div className="profile-avatar">
          <StoryImage
            src="https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80"
            alt="profile image"
          />
        </div>
        <div className="profile-info">
          <h2 className="profile-name">{item.name}</h2>
          {item.bio && <p className="profile-bio">{item.bio}</p>}
        </div>
      </div>

      {/* Body Sections */}
      <div className="profile-body">

        {/* Description */}
        {item.des && (
          <div className="profile-section">
            <p className="profile-description">{item.des}</p>
          </div>
        )}

        {/* Services */}
        {item.services && item.services.length > 0 && (
          <div className="profile-section">
            <div className="section-header">
              <MdCheckCircle className="section-icon services-icon" />
              <span className="section-title">Hizmetler</span>
            </div>
            <div className="chip-group">
              {item.services.map((i, idx) => (
                <span key={idx} className="chip chip-success">{i}</span>
              ))}
            </div>
          </div>
        )}

        {/* Districts */}
        {item.districts && item.districts.length > 0 && (
          <div className="profile-section">
            <div className="section-header">
              <MdLocationOn className="section-icon location-icon" />
              <span className="section-title">Bölgeler</span>
            </div>
            <div className="chip-group">
              {item.districts.map((i, idx) => (
                <span key={idx} className="chip chip-info">{i}</span>
              ))}
            </div>
          </div>
        )}

        {/* Forbiddens */}
        {item.forbiddens && item.forbiddens.length > 0 && (
          <div className="profile-section">
            <div className="section-header">
              <MdBlock className="section-icon forbidden-icon" />
              <span className="section-title">Yasaklar</span>
            </div>
            <div className="chip-group">
              {item.forbiddens.map((i, idx) => (
                <span key={idx} className="chip chip-error">{i}</span>
              ))}
            </div>
          </div>
        )}

      </div>

      {/* Contact Bar */}
      {item.chanels && item.chanels.length > 0 && (
        <div className="contact-bar">
          {item.chanels.map(i => getContactButton(i.S))}
        </div>
      )}
    </div>
  );
}

export default Profile;
